import { runClientComponent } from '../../_common/client/client-component-runner';
import { CustomerReviewImageGalleryComponent } from './customer-review-image-gallery.component';

runClientComponent({ customerReviewImageGallery: CustomerReviewImageGalleryComponent });
